import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: flex;
  justify-content: center;
  background-color: #e4e5e7;
  padding: 10px 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
    animation-duration: 0.3s !important;
  }

  .animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  .delay-1 {
    animation-delay: 0.15s;
  }

  .delay-2 {
    animation-delay: 0.25s;
  }

  .delay-3 {
    animation-delay: 0.35s;
  }

  .delay-4 {
    animation-delay: 0.45s;
  }

  .delay-5 {
    animation-delay: 0.55s;
  }

  .delay-6 {
    animation-delay: 0.65s;
  }

  .delay-7 {
    animation-delay: 0.75s;
  }

  .delay-8 {
    animation-delay: 0.85s;
  }

  ${mediaMaxWidth.smallDesktop} {
    padding: 10px 0;
  }

  ${mediaMaxWidth.tablet} {
    margin: 57px 0 0 0;
  }

  ${mediaMaxWidth.phone} {
    padding-top: 0;
  }
`;

export const Inner = styled.div`
  width: 960px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  flex-flow: row wrap;
`;

export const UserAndPerformance = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 360px;
  margin: 10px;

  ${mediaMaxWidth.smallDesktop} {
    flex: unset;
    width: 100%;
    height: unset;
  }
`;
